import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CountryClient, CountryView, SearchCountryParameters } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CountryService {
    constructor(private readonly client: CountryClient) {}

    async search(body: SearchCountryParameters): Promise<CountryView[]> {
        return await lastValueFrom(this.client.countrySearch(body));
    }

    async getById(id: number): Promise<CountryView> {
        return await lastValueFrom(this.client.countryGetById(id));
    }
}
